export const selectDistrictsState = state => state.districts;
export const selectDistrictsDetail = state => state.districts.district;
export const selectDistrictsMembers = state => state.districts.members;
export const selectDistrictsEvents = state => state.districts.events;
